export type TInlineTextSegment =
  | { type: "text"; text: string }
  | { type: "link"; text: string; url: string };

const INLINE_LINK_REGEX = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

export default function useInlineMarkdownLinks() {
  const parseInlineMarkdownLinks = (
    text: string | null | undefined
  ): TInlineTextSegment[] => {
    if (!text) return [];

    const segments: TInlineTextSegment[] = [];
    let lastIndex = 0;

    for (const match of text.matchAll(INLINE_LINK_REGEX)) {
      const index = match.index ?? 0;

      if (index > lastIndex) {
        segments.push({ type: "text", text: text.slice(lastIndex, index) });
      }

      segments.push({ type: "link", text: match[1], url: match[2] });
      lastIndex = index + match[0].length;
    }

    if (lastIndex < text.length) {
      segments.push({ type: "text", text: text.slice(lastIndex) });
    }

    return segments;
  };

  return {
    parseInlineMarkdownLinks
  };
}
